var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromocode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31217 7.75912C8.46409 7.91103 8.46409 8.15733 8.31217 8.30924C8.16026 8.46116 7.91396 8.46116 7.76204 8.30924C7.61013 8.15733 7.61013 7.91103 7.76204 7.75912C7.91396 7.6072 8.16026 7.6072 8.31217 7.75912",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.244 3.02509L10.093 3.00009C10.624 2.99509 11.135 3.20509 11.511 3.58009L20.415 12.4881C21.196 13.2691 21.196 14.5361 20.415 15.3171L15.321 20.4141C14.54 21.1961 13.272 21.1961 12.491 20.4141L3.58 11.5001C3.209 11.1291 3 10.6251 3 10.0991V7.28709C3 6.76109 3.209 6.25709 3.58 5.88609L5.86 3.60509C6.228 3.23709 6.725 3.02909 7.244 3.02509Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromocode);
export default __webpack_public_path__ + "static/media/promocode.3f0df73d880e953253145395efa61da7.svg";
export { ForwardRef as ReactComponent };